import { render, staticRenderFns } from "./layout-home.vue?vue&type=template&id=5911f32b&scoped=true&"
import script from "./layout-home.vue?vue&type=script&lang=js&"
export * from "./layout-home.vue?vue&type=script&lang=js&"
import style0 from "./layout-home.vue?vue&type=style&index=0&id=5911f32b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5911f32b",
  null
  
)

export default component.exports